import React from 'react'

import { Button, Dialog, DialogActions, DialogTitle } from '@mui/material'

type CampaignDialogProps = {
  isDialogOpen: boolean
  onCancel: (...args: any[]) => any
  onConfirm: (...args: any[]) => any
}

const CampaignDialog = ({ onConfirm, onCancel, isDialogOpen }: CampaignDialogProps) => (
  <Dialog onClose={onCancel} open={isDialogOpen}>
    <DialogTitle id="alert-dialog-title">Do you want to cancel campaign?</DialogTitle>
    <DialogActions>
      <Button color="primary" onClick={onCancel}>
        No
      </Button>
      <Button color="primary" onClick={onConfirm}>
        Yes
      </Button>
    </DialogActions>
  </Dialog>
)

export default CampaignDialog
